import { Path, Svg } from '@react-pdf/renderer';
import { QRCodeSVG } from 'qrcode.react';
import React from 'react';
import { renderToString } from 'react-dom/server';

import { parseHtmlSvgToPdf } from '../utils/parseHtmlSvgToPdf.tsx';

const createQRCodeSVG = (url: string): React.ReactNode => {
  return <QRCodeSVG value={url} size={128} />;
};

type QRCodeProps = {
  qrcode: string;
};

export const QRCode = ({ qrcode }: QRCodeProps): React.ReactNode => {
  const qrCodeSvg = createQRCodeSVG(qrcode);
  const paths = parseHtmlSvgToPdf(renderToString(qrCodeSvg));

  return (
    <Svg width='128' height='128' viewBox='0 0 55 55' data-testid='qrcode'>
      {paths.map((path, index) => (
        <Path key={path} fill={index === 0 ? 'white' : 'black'} d={path} />
      ))}
    </Svg>
  );
};
